import * as local from './local';

//-------- configure

export const DEBUG = local.DEBUG

export const DATE_FORMAT = "DD MMM YYYY"
export const TIME_FORMAT = "HH:mm"
export const DATETIME_FORMAT = "DD MMM YYYY HH:mm:ss"

//-------- constant

let _baseUrl
const getBackendAddr = () => {
  _baseUrl = (document.getElementById("REACT_APP_API_ADDR") as HTMLInputElement).value
  if (!_baseUrl) _baseUrl = local.BASE_URL
  if (!_baseUrl) _baseUrl = window.location.protocol + "//" + window.location.hostname + ":4021"
  return _baseUrl
}
export const BASE_URL = _baseUrl || getBackendAddr()

let _baseUrlVideo
const getBackendAddrVideo = () => {
  _baseUrl = (document.getElementById("REACT_APP_VIDEO_API_ADDR") as HTMLInputElement).value
  if (!_baseUrl) _baseUrl = local.BASE_URL_VIDEO
  if (!_baseUrl) _baseUrl = window.location.protocol + "//" + window.location.hostname + ":4021"
  return _baseUrl
}
export const BASE_URL_VIDEO = _baseUrlVideo || getBackendAddrVideo()

export const COMPANY_NAME = [
  { value: "Asia Aviation", },
  { value: "Airports Of Thailand", },
  { value: "AP (Thailand)", },
  { value: "Asset World Corp", },
  { value: "Banpu", },
  { value: "Bangkok Bank", },
  { value: "Bangchak Corp", },
  { value: "BCPG", },
  { value: "Bangkok Dusit Medical Services", },
  { value: "Beauty Community", },
  { value: "BEC World", },
  { value: "Bangkok Expressway and Metro", },
  { value: "B.Grimm Power", },
  { value: "Bumrungrad Hospital", },
  { value: "Berli Jucker", },
  { value: "Banpu Power", },
  { value: "BTS Group Holdings", },
  { value: "BTS Rail Mass Transit G Fund", },
  { value: "Carabao Group", },
  { value: "Central Plaza Hotel", },
  { value: "CH. Karnchang", },
  { value: "CK Power", },
  { value: "CP All", },
  { value: "Charoen Pokphand Foods", },
  { value: "Central Pattana", },
  { value: "Central Retail Corp", },
  { value: "Demco", },
  { value: "Energy Absolute", },
  { value: "Electricity Generating", },
  { value: "Eastern Polymer Group", },
  { value: "Esso Thailand", },
  { value: "Global Green Chemicals", },
  { value: "Siam Global House", },
  { value: "Global Power Synergy", },
  { value: "Gulf Energy Development", },
  { value: "Gunkul Engineering", },
  { value: "Home Product Center", },
  { value: "IRPC PCL", },
  { value: "Indorama Ventures", },
  { value: "Kasikornbank", },
  { value: "Kiatnakin Bank", },
  { value: "Krung Thai Bank", },
  { value: "Land and Houses", },
  { value: "LPN Development", },
  { value: "Siam Makro", },
  { value: "MEGA Lifesciences", },
  { value: "Minor International", },
  { value: "Muangthai Capital", },
  { value: "Osotspa PCL", },
  { value: "Pruksa Holding", },
  { value: "Power Solution Technologies", },
  { value: "PTT", },
  { value: "PTTEP", },
  { value: "PTT Global Chemical", },
  { value: "Quality Houses", },
  { value: "Ratch Group", },
  { value: "Srisawad Corp", },
  { value: "Siam Commercial Bank", },
  { value: "Siam Cement", },
  { value: "Scan Inter", },
  { value: "Supalai", },
  { value: "Star Petroleum Refining", },
  { value: "Sermsang Power Corp", },
  { value: "Sino-Thai E&C", },
  { value: "Sri Trang Gloves Thailand", },
  { value: "Tipco Asphalt", },
  { value: "Thanachart Capital", },
  { value: "Thailand Future Fund", },
  { value: "Thai Airways", },
  { value: "Tisco Financial", },
  { value: "TMB Bank", },
  { value: "Thailand Market Strategy", },
  { value: "Thai Oil", },
  { value: "TPC Power Holding", },
  { value: "TPI Polene Power", },
  { value: "Thai Union Group", },
  { value: "WHA Utilities & Power", },
]

export const COMPANY_CODE = [
  { value: "AP TB", },
  { value: "BDMS TB", },
  { value: "BH TB", },
  { value: "CK TB", },
  { value: "LH TB", },
  { value: "LPN TB", },
  { value: "PSH TB", },
  { value: "QH TB", },
  { value: "SPALI TB", },
  { value: "STEC TB", },
  { value: "AAV TB", },
  { value: "AOT TB", },
  { value: "AWC TB", },
  { value: "BEM TB", },
  { value: "BTS TB", },
  { value: "BTSGIF TB", },
  { value: "CENTEL TB", },
  { value: "CPN TB", },
  { value: "MINT TB", },
  { value: "SCC TB", },
  { value: "TFFIF TB", },
  { value: "THAI TB", },
  { value: "BANPU TB", },
  { value: "BCP TB", },
  { value: "BCPG TB", },
  { value: "BGRIM TB", },
  { value: "BPP TB", },
  { value: "CKP TB", },
  { value: "DEMCO TB", },
  { value: "EA TB", },
  { value: "EGCO TB", },
  { value: "EPG TB", },
  { value: "ESSO TB", },
  { value: "GGC TB", },
  { value: "GPSC TB", },
  { value: "GULF TB", },
  { value: "GUNKUL TB", },
  { value: "IRPC TB", },
  { value: "IVL TB", },
  { value: "PSTC TB", },
  { value: "PTT TB", },
  { value: "PTTEP TB", },
  { value: "PTTGC TB", },
  { value: "RATCH TB", },
  { value: "SCN TB", },
  { value: "SPRC TB", },
  { value: "SSP TB", },
  { value: "TASCO TB", },
  { value: "TOP TB", },
  { value: "TPCH TB", },
  { value: "TPIPP TB", },
  { value: "WHAUP TB", },
  { value: "STGT TB", },
  { value: "BBL TB", },
  { value: "KBANK TB", },
  { value: "KKP TB", },
  { value: "KTB TB", },
  { value: "MTC TB", },
  { value: "SAWAD TB", },
  { value: "SCB TB", },
  { value: "TCAP TB", },
  { value: "TISCO TB", },
  { value: "TMB TB", },
  { value: "BEAUTY TB", },
  { value: "BEC TB", },
  { value: "BJC TB", },
  { value: "CBG TB", },
  { value: "CPALL TB", },
  { value: "CPF TB", },
  { value: "CRC TB", },
  { value: "GLOBAL TB", },
  { value: "HMPRO TB", },
  { value: "MAKRO TB", },
  { value: "MEGA TB", },
  { value: "OSP TB", },
  { value: "TU TB", },
  { value: "TMZ TB", },
]

export const COMPANY_SECTOR = [
  { value: "Real Estate", },
  { value: "Healthcare", },
  { value: "Construction", },
  { value: "Transportation", },
  { value: "Leisure & Hotels", },
  { value: "Coal & Consumable Fuels", },
  { value: "Oil & Gas", },
  { value: "Electric Utilities", },
  { value: "Independent Power Producers", },
  { value: "Chemicals", },
  { value: "Household & Personal Products", },
  { value: "Banks", },
  { value: "Diversified Financials", },
  { value: "Retailing", },
  { value: "Media", },
  { value: "Food Beverage & Tobacco", },
  { value: "Food & Staples Retailing", },
]

export const ANALYST_NAME = [
  { value: "Chutima Woramontri", },
  { value: "Somkij Oranchatchawan", },
  { value: "Suwat Sinsadok", },
  { value: "Yuvanart Suwanumphai", },
  { value: "Yuvanart  Suwanumphai", },
  { value: "Yuwanee Prommaporn", },
  { value: "Songklod Wongchai", },
]

export const RECO = [
  { value: "BUY", },
  { value: "HOLD", },
  { value: "REDUCE", },
]